/**
#  * Copyright (c) 2008 Pasyuk Sergey (www.codeasily.com)
#  * Licensed under the MIT License:
#  * @see http://www.codeasily.com/jquery/multi-column-list-with-jquery
#  */
jQuery.fn.makeacolumnlists=function(a){a=jQuery.extend({cols:2,colWidth:0,equalHeight:false,startN:1},a);if(jQuery("> li",this)){this.each(function(l){var l=jQuery(".li_container").size(),o=0,p=0,n=jQuery(this),g=n.attr("class"),x=jQuery("> li",this).size(),h=Math.ceil(x/a.cols),e=n.width(),c=(isNaN(parseInt(n.css("borderLeftWidth"),10))?0:parseInt(n.css("borderLeftWidth"),10)),w=(isNaN(parseInt(n.css("borderRightWidth"),10))?0:parseInt(n.css("borderRightWidth"),10)),v=parseInt(n.css("paddingLeft"),10),r=parseInt(n.css("paddingRight"),10),u=parseInt(n.css("marginLeft"),10),q=parseInt(n.css("marginRight"),10),d=Math.floor((e-(a.cols-1)*(c+w+v+r+u+q))/a.cols);if(a.colWidth){d=a.colWidth}var b=1,j=h;jQuery(this).addClass("li_cont1").wrap('<div id="li_container'+(++l)+'" class="li_container"></div>');for(var s=0;s<=x;s++){if(s>=j){j+=h;b++}var z=jQuery("> li:eq("+s+")",this);z.addClass("li_col"+b);if(jQuery(this).is("ol")){z.attr("value",""+(s+a.startN))+""}}jQuery(this).css({cssFloat:"left",width:""+d+"px"});for(b=2;b<=a.cols;b++){if(jQuery(this).is("ol")){jQuery("li.li_col"+b,this).appendTo("#li_container"+l).wrapAll('<ol class="li_cont'+b+" "+g+'" style="float:left; width: '+d+'px;"></ol>')}else{jQuery("li.li_col"+b,this).appendTo("#li_container"+l).wrapAll('<ul class="li_cont'+b+" "+g+'" style="float:left; width: '+d+'px;"></ul>')}}if(a.equalHeight=="li"){for(b=1;b<=a.cols;b++){jQuery("#li_container"+l+" li").each(function(){var y=jQuery(this);var i=(isNaN(parseInt(y.css("borderTopWidth"),10))?0:parseInt(y.css("borderTopWidth"),10));var t=(isNaN(parseInt(y.css("borderBottomWidth"),10))?0:parseInt(y.css("borderBottomWidth"),10));o=y.height()+parseInt(y.css("paddingTop"),10)+parseInt(y.css("paddingBottom"),10)+i+t;p=(o>p)?o:p})}for(b=1;b<=a.cols;b++){var f=jQuery("#li_container"+l+" li");var k=(isNaN(parseInt(f.css("borderTopWidth"),10))?0:parseInt(f.css("borderTopWidth"),10));var m=(isNaN(parseInt(f.css("borderBottomWidth"),10))?0:parseInt(f.css("borderBottomWidth"),10));mh=p-(parseInt(f.css("paddingTop"),10)+parseInt(f.css("paddingBottom"),10)+k+m);f.height(mh)}}else{if(a.equalHeight=="ul"||a.equalHeight=="ol"){for(b=1;b<=a.cols;b++){jQuery("#li_container"+l+" .li_cont"+b).each(function(){var y=jQuery(this);var i=(isNaN(parseInt(y.css("borderTopWidth"),10))?0:parseInt(y.css("borderTopWidth"),10));var t=(isNaN(parseInt(y.css("borderBottomWidth"),10))?0:parseInt(y.css("borderBottomWidth"),10));o=y.height()+parseInt(y.css("paddingTop"),10)+parseInt(y.css("paddingBottom"),10)+i+t;p=(o>p)?o:p})}for(b=1;b<=a.cols;b++){var f=jQuery("#li_container"+l+" .li_cont"+b);var k=(isNaN(parseInt(f.css("borderTopWidth"),10))?0:parseInt(f.css("borderTopWidth"),10));var m=(isNaN(parseInt(f.css("borderBottomWidth"),10))?0:parseInt(f.css("borderBottomWidth"),10));mh=p-(parseInt(f.css("paddingTop"),10)+parseInt(f.css("paddingBottom"),10)+k+m);f.height(mh)}}}jQuery("#li_container"+l).append('<div style="clear:both; overflow:hidden; height:0px;"></div>')})}};jQuery.fn.uncolumnlists=function(){jQuery(".li_cont1").each(function(b){var c=jQuery("#li_container"+(++b)+" .li_cont1 > li").size();if(jQuery("#li_container"+b+" .li_cont1").is("ul")){jQuery("#li_container"+b+" > ul > li").appendTo("#li_container"+b+" ul:first");for(var a=1;a<=c;a++){jQuery("#li_container"+b+" ul:first li").removeAttr("class").removeAttr("style")}jQuery("#li_container"+b+" ul:first").removeAttr("style").removeClass("li_cont1").insertBefore("#li_container"+b)}else{jQuery("#li_container"+b+" > ol > li").appendTo("#li_container"+b+" ol:first");for(var a=1;a<=c;a++){jQuery("#li_container"+b+" ol:first li").removeAttr("class").removeAttr("style")}jQuery("#li_container"+b+" ol:first").removeAttr("style").removeClass("li_cont1").insertBefore("#li_container"+b)}jQuery("#li_container"+b).remove()})};

/* placeholder */
(function($){$.InFieldLabels=function(b,c,d){var f=this;f.$label=$(b);f.label=b;f.$field=$(c);f.field=c;f.$label.data("InFieldLabels",f);f.showing=true;f.init=function(){f.options=$.extend({},$.InFieldLabels.defaultOptions,d);if(f.$field.val()!=""){f.$label.hide();f.showing=false};f.$field.focus(function(){f.fadeOnFocus()}).blur(function(){f.checkForEmpty(true)}).bind('keydown.infieldlabel',function(e){f.hideOnChange(e)}).change(function(e){f.checkForEmpty()}).bind('onPropertyChange',function(){f.checkForEmpty()})};f.fadeOnFocus=function(){if(f.showing){f.setOpacity(f.options.fadeOpacity)}};f.setOpacity=function(a){f.$label.stop().animate({opacity:a},f.options.fadeDuration);f.showing=(a>0.0)};f.checkForEmpty=function(a){if(f.$field.val()==""){f.prepForShow();f.setOpacity(a?1.0:f.options.fadeOpacity)}else{f.setOpacity(0.0)}};f.prepForShow=function(e){if(!f.showing){f.$label.css({opacity:0.0}).show();f.$field.bind('keydown.infieldlabel',function(e){f.hideOnChange(e)})}};f.hideOnChange=function(e){if((e.keyCode==16)||(e.keyCode==9))return;if(f.showing){f.$label.hide();f.showing=false};f.$field.unbind('keydown.infieldlabel')};f.init()};$.InFieldLabels.defaultOptions={fadeOpacity:0.5,fadeDuration:300};$.fn.inFieldLabels=function(c){return this.each(function(){var a=$(this).attr('for');if(!a)return;var b=$("input#"+a+"[type='text'],"+"input#"+a+"[type='password'],"+"textarea#"+a);if(b.length==0)return;(new $.InFieldLabels(this,b[0],c))})}})(jQuery);

(function($){
	/*! akordeon */
	$.fn.akordeon = function(){
		var
			$this = $(this),
			a_speed = 500,
			a_easing = 'easeInOutQuint';

		if($this.parent('.akordeon').hasClass('expanded')){
			$this.stop().animate({opacity:0},{
				duration: a_speed,
				easing: a_easing,
				queue: false,
				start: function(){
					$this.slideUp(a_speed, a_easing);
				},
				complete: function(){
					$this.parent().removeClass('expanded').addClass('collapsed');
				}
			});
		}else{
			$this.stop().animate({opacity:1},{
				duration: a_speed,
				easing: a_easing,
				queue: false,
				start: function(){
					$this.slideDown(a_speed, a_easing);
					$this.parent().removeClass('collapsed').addClass('expanded');
				},
				done: function(){
					$this.css('height','auto');
				}
			});
		}
	};
})(jQuery);


$(document).ready(function() {
	$(".placeholder").inFieldLabels({fadeOpacity:0.2});

	$('.scrollpane').jScrollPane();

	var $w = $(window),
        $header = $("#header"),
        header_shadow;

    $w.on("scroll.shadow", function () {
        var st = $w.scrollTop(),
            offset = $header.height();

        if (st >= offset && !header_shadow) {
            $header.addClass("shadow");
            header_shadow = true;
        } else if (st < offset && header_shadow) {
            $header.removeClass("shadow");
            header_shadow = false;
        }
    });

    $("#btn_menu").on("click", function (e) {
        $(document.body).toggleClass("open--menu");

        e.preventDefault();
    });

	if ($("#carousel_1").length) {
        $("#carousel_1").carouFredSel({
            // height: 475,
            // width: 996,
            width: "100%",
            responsive: true,
            items: {
                visible: 1
            },
            align: false,
            scroll: {
                items: 1,
                easing: "easeInOutExpo",
                duration		: 1000,
                timeoutDuration	: 5000,
                pauseOnHover: true,
                onBefore: function(data) {
                    data.items.visible.children().css('opacity',0).delay(500).fadeTo(800, 1);
                    data.items.old.find('.cmain').animate({left:-100, opacity: 0}, 500, "easeOutSine");
                    data.items.old.find('.cimg').animate({opacity: 0}, 500);
                },
                onAfter: function(data) {
                    data.items.old.find('.cmain').css({left:0});
                }
            },
            prev: {
                button: '#c1_prev'
            },
            next: {
                button: '#c1_next'
            }
        });
        $(window).on("resize", function () {
            $("#carousel_1_wrap .caroufredsel_wrapper, #carousel_1").css("height", $("#carousel_1_wrap").height());
        });
    }

	if ($("#carousel_2").length) {
        $("#carousel_2").carouFredSel({
            // height: 337,
            // width: 506,
            width: "100%",
            responsive: true,
            items: {
                visible: 1
            },
            scroll: {
                items: 1,
                easing: "easeInOutExpo",
                duration		: 1000,
                timeoutDuration	: 5000,
                pauseOnHover: true
            },
            prev: {
                button: '#c2_prev'
            },
            next: {
                button: '#c2_next'
            }
        });
        $(window).on("resize", function () {
            $("#carousel_2_wrap .caroufredsel_wrapper, #carousel_2").css("height", $("#carousel_2_wrap").height());
        });
    }

	// $('#dyst_block').makeacolumnlists({cols:3, colWidth:0, equalHeight:'ul', startN:1});

	$('.akordeon').each(function(){
		if($(this).hasClass('collapsed')){
			$(this).children('.a-main').hide();
		}
	});
	$('.akordeon > .a-btn').click(function(){
		$(this).next('.a-main').akordeon();
 	});

	$("#select_country").on("change", function () {
        $("#dyst_list > li[data-country='" + $(this).val() + "']")
            .show()
            .siblings("li")
            .hide();
    }).trigger("change");

	$("#dyst_foo, #kont_foo").on("click", "> h1", function (e) {
	    $(e.delegateTarget).toggleClass("collapsed");
    });
});

function sendMessage(){
    if(!$('#contact-form input[name="telemail"]').val() || !$('#contact-form textarea[name="wiadomosc"]').val()) return;
    $('#contact-form input[type="submit"]').val('Wysyłanie ... ').attr('disabled', 'disabled');
    $.ajax({
        type: 'post',
        async: false,
        url: '/view/email',
        data: $('#contact-form').serialize(),
        success: function(res){
            if(res == '1'){
                setMessageSuccess();
            }
            else{
                setMessageError();
            }
        },
        error: function(){
            setMessageError();
        }
    });
}

function setMessageSuccess(){
    $('#contact-form').html('Wysłano wiadomość');
}

function setMessageError(){
    $('#contact-form').html('Wysłano wiadomość');
    $('#contact-form input[type="submit"]').val('Wyślij').attr('disabled', false).after('<p>Błąd podczas wysyłania. Spróbuj ponownie</p>');
}